import { useEffect } from "react"
import {Clients} from "config/constant"
import {useApiDefaults} from "hooks/useApiDefaults"

const MosersText = "Moser’s Foods | Your Locally Owned Family Food Store" 

export function SeoConfig() {
  const apiDefaults = useApiDefaults()
 
  useEffect(() => {
    if (apiDefaults.RSAClientId === Clients.Mosers) {
      document.title = MosersText
    }
  }, [apiDefaults.RSAClientId])

  if (apiDefaults.RSAClientId !== Clients.Mosers) {
    return null
  }

  return (
    <h1 style={{
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      borderWidth: 0
    }}>
      {MosersText}
    </h1>
  )
}
